<app-admin-student-platform-header></app-admin-student-platform-header>

<section class="user-detail-page">
  <!-- TOP BACK BUTTON HEADER -->
  <div class="top-nav">
    <button class="back-btn" (click)="goBack()">
      <i class="bi bi-arrow-left"></i>
      Back to User Management
    </button>
  </div>

  <div class="user-detail-card" *ngIf="user && !isLoading">
    <!-- USER HEADER BANNER -->
    <div class="user-header-banner">
      <div class="avatar">
        {{ getInitials(user?.name) }}
      </div>

      <div class="user-text">
        <div class="name-status">
          <h2 class="name m-0">{{ user?.name }}</h2>
          <span class="badge" [ngClass]="getPaymentClass(user?.paymentStatus)">
            {{ user?.paymentStatus | titlecase }}
          </span>
        </div>
        <p class="email m-0"><i class="bi bi-envelope"></i> {{ user?.email }}</p>
      </div>
    </div>

    <!-- MAIN TABS SWITCHER -->
    <div class="detail-tabs-header">
      <button class="detail-tab-btn" [class.active]="activeDetailTab === 'overview'"
        (click)="activeDetailTab = 'overview'">
        <i class="bi bi-person"></i>
        Candidate Overview
      </button>
      <button class="detail-tab-btn" [class.active]="activeDetailTab === 'job_applications'"
        (click)="activeDetailTab = 'job_applications'">
        <i class="bi bi-briefcase"></i>
        Job Applications
        <span class="tab-count-badge">{{ jobApplications.length }}</span>
      </button>
    </div>

    <!-- TAB 1: CANDIDATE OVERVIEW -->
    <div class="tab-content" *ngIf="activeDetailTab === 'overview'">
      <!-- PERSONAL & ACADEMIC INFO -->
      <h3 class="summary-title"><i class="bi bi-person-lines-fill"></i> Personal & Academic Details</h3>
      <div class="info-grid">
        <div class="info-item">
          <p class="label"><i class="bi bi-calendar"></i> Registered</p>
          <p class="value">{{ user?.registered | date: dateFormat }}</p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-telephone"></i> Phone Number</p>
          <p class="value">{{ user?.phone_number || 'N/A' }}</p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-mortarboard"></i> College Name</p>
          <p class="value">{{ user?.college_name || 'N/A' }}</p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-geo-alt"></i> City</p>
          <p class="value">{{ user?.city || 'N/A' }}</p>
        </div>
        <!--<div class="info-item">
          <p class="label"><i class="bi bi-pin-map"></i> Pincode</p>
          <p class="value">{{ user?.pincode || 'N/A' }}</p>
        </div>-->
        <div class="info-item">
          <p class="label"><i class="bi bi-credit-card"></i> Payment Status</p>
          <span class="badge" [ngClass]="getPaymentClass(user?.paymentStatus)">
            {{ user?.paymentStatus | titlecase }}
          </span>
        </div>
      </div>

      <hr class="section-divider">

      <!-- REGISTRATION & LOGIN INFO -->
      <h3 class="summary-title"><i class="bi bi-shield-lock"></i> Registration & Login Info</h3>
      <div class="info-grid">
        <div class="info-item">
          <p class="label"><i class="bi bi-box-arrow-in-right"></i> Registration Source</p>
          <p class="value">
            <span class="register-source">{{ user?.registration_source || 'Direct' }}</span>
          </p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-laptop"></i> Last Login Source</p>
          <p class="value">{{ user?.last_login_source || 'N/A' }}</p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-clock-history"></i> Last Login At</p>
          <p class="value">
            {{ user?.last_login_at ? (user?.last_login_at | date: dateTimeFormat) : 'Never' }}
          </p>
        </div>
        <div class="info-item">
          <p class="label"><i class="bi bi-person-check"></i> Account Status</p>
          <span class="status-indicator" [class.active]="user?.is_active">
            {{ user?.is_active ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </div>

      <hr class="section-divider">

      <!-- ACTIVITY SUMMARY GRID -->
      <h3 class="summary-title"><i class="bi bi-bar-chart-line"></i> Activity Summary</h3>
      <div class="summary-grid">
        <!--<div class="summary-card">
          <div class="summary-icon blue"><i class="bi bi-journal-bookmark"></i></div>
          <h4 class="summary-number">{{ user?.enrolledCourses || 0 }}</h4>
          <p class="summary-text">Enrolled Courses</p>
        </div>
        <div class="summary-card">
          <div class="summary-icon orange"><i class="bi bi-pencil-square"></i></div>
          <h4 class="summary-number">{{ user?.quizAttempts || 0 }}</h4>
          <p class="summary-text">Quiz Attempts</p>
        </div>-->
        <div class="summary-card">
          <div class="summary-icon green"><i class="bi bi-camera-video"></i></div>
          <h4 class="summary-number">{{ user?.ai_interview_count || 0 }}</h4>
          <p class="summary-text">AI Interviews</p>
        </div>
        <div class="summary-card">
          <div class="summary-icon purple"><i class="bi bi-award"></i></div>
          <h4 class="summary-number">{{ user?.ai_mock_test_count || 0 }}</h4>
          <p class="summary-text">AI Mock Tests</p>
        </div>
        <!--<div class="summary-card">
          <div class="summary-icon red"><i class="bi bi-people"></i></div>
          <h4 class="summary-number">{{ user?.mentor_sessions_booked || 0 }}</h4>
          <p class="summary-text">Mentor Sessions</p>
        </div>-->
        <div class="summary-card">
          <div class="summary-icon teal"><i class="bi bi-briefcase"></i></div>
          <h4 class="summary-number">{{ user?.job_applied_count ?? jobApplications.length }}</h4>
          <p class="summary-text">Jobs Applied</p>
        </div>
      </div>
    </div>

    <!-- TAB 2: JOB APPLICATIONS -->
    <div class="tab-content" *ngIf="activeDetailTab === 'job_applications'">
      <div class="job-apps-header">
        <div class="header-title-search">
          <div class="title-text">
            <h3>Job Applications</h3>
            <p>Track {{ user?.name }}'s job application status and progress</p>
          </div>
          <div class="job-search-box" *ngIf="jobApplications.length > 0">
            <i class="bi bi-search search-icon"></i>
            <input type="text" class="job-search-input" placeholder="Search by job title..."
              [(ngModel)]="jobSearchQuery" />
            <button *ngIf="jobSearchQuery" class="clear-search-btn" (click)="clearJobSearch()" title="Clear search">
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="job-apps-table-wrapper" *ngIf="filteredJobApplications.length > 0 && !isLoadingJobApplications">
        <table class="job-apps-table">
          <thead>
            <tr>
              <th>JOB TITLE</th>
              <th>COMPANY</th>
              <th>APPLIED ON</th>
              <th>CURRENT STATUS</th>
              <th>ASSESSMENT</th>
              <th>INTERVIEW</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let app of paginatedJobApplications">
              <td class="job-title-cell">{{ app.job_title }}</td>
              <td class="company-cell">{{ app.company_name }}</td>
              <td>{{ app.applied_on | date: 'MMM d, y' }}</td>
              <td>
                <span class="status-pill" [ngClass]="getStatusBadgeClass(getFormattedJobStatus(app))">
                  {{ getFormattedJobStatus(app) }}
                </span>
              </td>
              <td>{{ app.assessment_score || (app.assessment?.score != null ? app.assessment.score : '--') }}</td>
              <td>{{ app.interview_status || (app.interview?.status ? (app.interview.status | titlecase) : '--') }}</td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATION FOOTER -->
        <div class="pagination" *ngIf="filteredJobApplications.length > 0">
          <p>
            Showing
            <strong>{{ (jobCurrentPage - 1) * jobPageSize + 1 }}</strong> –
            <strong>{{ getJobEndIndex() }}</strong>
            of <strong>{{ filteredJobApplications.length }}</strong>
          </p>

          <div class="page-controls">
            <button (click)="changeJobPage(jobCurrentPage - 1)" [disabled]="jobCurrentPage === 1">‹</button>

            <button *ngIf="jobCurrentPage > 2" (click)="changeJobPage(1)">1</button>

            <span *ngIf="jobCurrentPage > 3" class="dots">…</span>

            <button *ngIf="jobCurrentPage > 1" (click)="changeJobPage(jobCurrentPage - 1)">
              {{ jobCurrentPage - 1 }}
            </button>

            <button class="active">{{ jobCurrentPage }}</button>

            <button *ngIf="jobCurrentPage < totalJobPages" (click)="changeJobPage(jobCurrentPage + 1)">
              {{ jobCurrentPage + 1 }}
            </button>

            <span *ngIf="jobCurrentPage < totalJobPages - 2" class="dots">…</span>

            <button *ngIf="jobCurrentPage < totalJobPages - 1" (click)="changeJobPage(totalJobPages)">
              {{ totalJobPages }}
            </button>

            <button (click)="changeJobPage(jobCurrentPage + 1)" [disabled]="jobCurrentPage === totalJobPages || totalJobPages === 0">›</button>
          </div>
        </div>
      </div>

      <!-- NO MATCHING SEARCH RESULTS -->
      <div class="no-job-apps"
        *ngIf="jobApplications.length > 0 && filteredJobApplications.length === 0 && !isLoadingJobApplications">
        <i class="bi bi-search"></i>
        <h4>No matching job applications found</h4>
        <p>No job applications found matching "{{ jobSearchQuery }}".</p>
        <button class="btn-clear-filter mt-2" (click)="clearJobSearch()">Clear Search</button>
      </div>

      <!-- NO JOB APPLICATIONS -->
      <div class="no-job-apps" *ngIf="jobApplications.length === 0 && !isLoadingJobApplications">
        <i class="bi bi-briefcase"></i>
        <h4>No job applications found</h4>
        <p>This user has not applied for any jobs yet.</p>
      </div>

      <!-- LOADING JOB APPLICATIONS -->
      <div class="loading-state" *ngIf="isLoadingJobApplications">
        <p>Loading job applications...</p>
      </div>
    </div>

  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2">Loading user details...</p>
  </div>

  <div class="no-data-state" *ngIf="!user && !isLoading">
    <i class="bi bi-person-exclamation text-muted display-4"></i>
    <h3>User Not Found</h3>
    <p>User details are unavailable.</p>
    <button class="back-btn mt-3" (click)="goBack()">Back to User Management</button>
  </div>
</section>